import '@/scripts/main';
import './theme.scss';
import '../../scripts/snippets/carousel.js';
import '../../scripts/snippets/product-tile.js';
import '../../scripts/snippets/quick-buy.js';
import { initMinicart } from '@components/minicart';
import { initFirstWishlit } from '@components/wishlist';
import '../../scripts/templates/page.rma.js';

(() => {
  initMinicart();
  initFirstWishlit();
})();
